import React, { useState } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import List from './pages/List'
import NewClient from './pages/New'
import EditClient from './pages/Edit'
import Presentation from './pages/Presentation'

const Ipsa = () => {
    const SetSidebar = (value) => {
        setSidebarState((prevState) => ({
            ...prevState,
            sidebarOpen: value,
        }))
    }

    const SetFullScreen = (value) => {
        setSidebarState((prevState) => ({
            ...prevState,
            fullScreen: value,
        }))
    }

    const [sidebarState, setSidebarState] = useState({
        sidebarOpen: true,
        setSidebar: SetSidebar,
        fullScreen: false,
        setFullScreen: SetFullScreen,
    })

    return (
        <Switch>
            <Route path="/clients" exact component={List} />
            <Route path="/clients/new" component={NewClient} />

            <Redirect
                from="/clients/:id/presentation"
                to="/clients/:id/presentation/income"
                exact
            />
            <Route
                path="/clients/:id/presentation/:graph"
                render={({ match }) => (
                    <Presentation url={match.url} id={match.params.id} graph={match.params.graph} />
                )}
            />
            <Route
                path="/clients/:id"
                render={({ match }) => <EditClient id={match.params.id} />}
            />
        </Switch>
    )
}

export default Ipsa
